<div class="d-flex flex-column">
  <div class="login-top-bar d-flex flex-row justify-content-between align-items-center">
      <div class="logo-container pointer">
          <a href="https://knowledgehook.com">
              <kh-img path="kh-logo.svg" class="desktop logo"></kh-img>
              <kh-img path="kh-logo-book-only.svg" class="mobile logo"></kh-img>
          </a>
      </div>
      <div>
        <ng-container *ngIf="showLanguageSelector">
          <kh-dropdown-menu [alignmentRight]="true" class="ml-xs" *ngIf="availableLocales$ | async as availableLocales">
            <div class="language-picker text-center pointer" header>
              <svg class="global-icon">
                <use href="images/global.svg#Layer_1"></use>
              </svg>

              <span class="pl-kh-1 align-middle language-picker-text">{{localeCode | uppercase }}</span>
            </div>
            <kh-dropdown-menu-item *ngFor="let locale of availableLocales" role="menuitem" (click)="setLanguage(locale.LocaleId)">
              <div>{{locale.Language}}</div>
            </kh-dropdown-menu-item>
          </kh-dropdown-menu>
        </ng-container>
       


          <span class="pl-kh-3 kh-medium-title-text signup pointer desktop" (click)="navigateStudentLogin()" *ngIf="showStudentLogin">
              {{ 'LOGIN_TOP_BAR.STUDENT_LOGIN' | translate }}
          </span>
          <span class="pl-kh-3 kh-medium-title-text signup pointer" [routerLink]="loginRoute" *ngIf="showLogin">
              {{ 'LOGIN_TOP_BAR.LOGIN' | translate }}
          </span>
          <span class="pl-kh-3 kh-medium-title-text signup pointer" (click)="navigateSignUp()" [routerLink]="registerRoute" *ngIf="showSignup" data-testid="sign-up-button">
              {{ 'LOGIN_TOP_BAR.SIGN_UP' | translate }}
          </span>
      </div>
  </div>
  <div class="divider"></div>

  <div class="back-button-container mt-kh-4" *ngIf="!hideBack">
    <kh-back-button (clickEvent)="backButton()"></kh-back-button>
  </div>
</div>
